<template>
<div>
    <el-row class="cs-filter-row">
        <el-col class="text-left">
            <el-select v-model="selectedTrainingCategory" placeholder="请选择" @change="onTrainingCategoryChange">
                <el-option v-for="item in trainingCategoryList" :key="item.Id" :label="item.Name" :value="item.Id">
                </el-option>
            </el-select>
            <el-button class="cs-pagination-header-add" type="primary" plain icon="el-icon-plus" @click="addTrainingTerm">添加学期</el-button>
        </el-col>
    </el-row>
    <el-row class="grid-content">
        <el-col>
            <el-table ref="trainingTermTable" v-loading="loading" :data="currentPageTerms" :header-row-class-name="'el-table-header'" :cell-class-name="cellStyle">
                <el-table-column prop="DisplayLable" label="学期" fixed :min-width="columnWidth">
                </el-table-column>
                <el-table-column prop="IsCurrentTerm" label="当前学期" fixed :min-width="columnWidth">
                    <template slot-scope="scope">
                        <span v-if="scope.row.IsCurrentTerm">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="DateRangeStr" label="上课日期" :min-width="columnWidth">
                </el-table-column>
                <el-table-column label="课程安排" :min-width="300">
                    <template slot-scope="scope">
                        <el-row v-for="courseSchedule in scope.row.TrainingCourseSchedules" :key="courseSchedule.CouseId">
                            <el-col :span="6">
                                <span>{{courseSchedule.CourseName}}</span>
                            </el-col>
                            <el-col :span="18">
                                <el-row v-for="schedule in courseSchedule.TrainingCourseScheduleDetails" :key="schedule.Guid">
                                    <span>{{schedule.DayOfWeekText}}</span>
                                    <span>{{schedule.StartTimeText}}</span>
                                    <span>{{schedule.EndTimeText}}</span>
                                </el-row>
                            </el-col>
                        </el-row>
                    </template>
                </el-table-column>
                <el-table-column prop="Name" label="编辑" fixed="right" :min-width="80">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="onEditTrainingTerm(scope.row)">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50, 100]" :page-size="20" layout="total, sizes, prev, pager, next, jumper" :total="recordTotal">
            </el-pagination>
        </el-col>
    </el-row>
    <el-dialog title="" :center="true" :close-on-click-modal="false" width="800px" :visible.sync="displayTermEditor" top="5vh">
        <trainingTermEditor ref="trainingTermEditor" :mode="editMode" :editingForm="editingForm" :currentTerm="currentTerm" :isVisible="displayTermEditor" v-on:saveTermSuccess="onSaveTermSuccess" v-on:dialogFormVisibleEvent="onTermEditorVisibleEvent"></trainingTermEditor>
    </el-dialog>
</div>
</template>

<style lang="scss" scoped>
.cs-contentContainer {
    .grid-content {
        margin-top: 15px;

        .cs-schedule-buttonContainer {
            text-align: right;
        }
    }

    .gray {
        color: gray;
    }
}
.cs-filter-row{
    padding-top: 20px;
}
</style>

<script>
import trainingTermEditor from "../../components/termManagement/trainingTermEditor"
import {
    getAllTerms,
    getTrainingTerms,
    getTrainingCategoryCourses
} from "../../service/termManage.service.js";
import {
    getCurrentTerm
} from "../../service/common.service.js";
import {
    formatTimeToInt60,
    dayOfWeekToString
} from "../../config/mUtils.js";
import {
    getTrainingCategories
} from "../../service/globalPriceSetting.service.js"
export default {
    data() {
        return {
            trainingTerms: [],
            currentPageTerms: [],
            loading: false,
            columnWidth: 110,
            currentPage: 1,
            currentPageSize: 20,
            recordTotal: 0,
            editMode: "add",
            editingForm: {},
            displayTermEditor: false,
            currentTerm: {},
            activeCourseType: '1',
            trainingCategoryList: [],
            selectedTrainingCategory: null,
        }
    },
    components: {
        trainingTermEditor
    },
    created() {
        getTrainingCategories(3).then(result => {
            if (!!result && result.success) {
                this.trainingCategoryList = result.data;
            }
        });
    },
    methods: {
        cellStyle(cell) {
            let cellClass = "";
            if ((cell.rowIndex + 1) % 2 == 1) {
                cellClass = "el-table-cell-single";
            } else {
                cellClass = "el-table-cell-double";
            }
            return cellClass;
        },
        getColumnWidth(value) {
            if (!value) {
                return 150;
            }
            return value;
        },
        addTrainingTerm() {
            if (!this.selectedTrainingCategory) {
                this.$message({
                    type: "warning",
                    message: "请先选择业务"
                });
                return;
            }
            this.editingForm = {
                Id: 0,
                Year: null,
                Season: null,
                StartDate: null,
                EndDate: null,
                Name: '',
                IsCurrentTerm: false,
                TrainingCategoryId: this.selectedTrainingCategory,
                TrainingCourseSchedules: []
            };
            this.displayTermEditor = true;
            this.editMode = "add";

        },
        onTrainingCategoryChange() {
            this.loading = true;
            this.loadTrainingTerms();
        },
        onEditTrainingTerm(row) {
            this.editMode = "edit";
            this.editingForm = row;
            this.displayTermEditor = true; 
        },
        loadTrainingTerms() {
            getTrainingTerms(this.selectedTrainingCategory).then(result => {
                if (!!result && result.success) {
                    this.trainingTerms = result.data;
                    this.recordTotal = this.trainingTerms.length;
                    this.getCurrentPageTerms();
                }
                this.loading = false;
            })
        },
        getCurrentPageTerms() {
            let start = (this.currentPage - 1) * this.currentPageSize;
            let end = start + this.currentPageSize;
            this.currentPageTerms = this.trainingTerms.slice(start, end);
            if (this.currentPageTerms.length > 0) {
                this.currentPageTerms.forEach(element => {
                    if (element.TrainingCourseSchedules && element.TrainingCourseSchedules.length > 0) {
                        element.TrainingCourseSchedules.forEach(el => {
                            el.TrainingCourseScheduleDetails.forEach(e => { 
                                if(e.DayOfWeek == 0){
                                    e.DayOfWeek = 7;
                                }
                                if (e.StartTime != null) {
                                    e.StartTimeInt = formatTimeToInt60(e.StartTimeText);
                                }
                                if (e.EndTime != null) {
                                    e.EndTimeInt = formatTimeToInt60(e.EndTimeText, true);
                                }
                            });
                        });
                    }
                })
            }

        },
        handleSizeChange(value) {
            this.currentPageSize = value;
            this.currentPage = 1;
            this.getCurrentPageTerms();
        },
        handleCurrentChange(index) {
            this.currentPage = index;
            this.loadTrainingTerms();
            this.getCurrentPageTerms();
        },
        onTermEditorVisibleEvent() {
            this.displayTermEditor = false;
            this.$refs.termEditor.close();
        },
        onSaveTermSuccess() {
            this.displayTermEditor = false;
            this.loadTrainingTerms()
        },
    },
    watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/termManagement/trainingTerms.vue